import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { BasicIcon } from "@pickit/pickit-components";
import { RoadSafetyFirstPageProps } from "./types";
import "../../OperateTab/operateTab.scss";

const FirstPage: React.FC<RoadSafetyFirstPageProps> = ({
  next,
  bicycles,
  motorcycles,
  cars,
  generalInfo,
}) => {

  const { t } = useTranslation();

  const options = [
    {
      label: t("Bicycles:title"),
      page: bicycles,
    },
    {
      label: t("Motorcycles:title"),
      page: motorcycles,
    },
    {
      label: t("Cars:title"),
      page: cars,
    },
    {
      label: t("GeneralInfo:title"),
      page: generalInfo,
    },
  ];

  const handleClick = useCallback(
    (page: string) => () => {
      next(page);
    },
    [next]
  );

  return (
    <div>
      {options.map((option) => (
        <button onClick={handleClick(option.page)} className="operate-option">
          <p>{option.label}</p>
          <BasicIcon name="chevron-right" clickable />
        </button>
      ))}
    </div>
  );
};

export default FirstPage;
